module.exports = __webpack_public_path__ + "img/Vue.c2a605fb.png";